module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_7-8e06f89b55ec0b211ab5d42d4eede124.jpg";